module.exports = __webpack_public_path__ + "static/card1-0295acdcb2880c8347965a7f67e2dbab.svg";